import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  handleGetAllGames,
  GetAllGamesParams,
} from "../../api-clients/gamesClient";

interface UseGamesQueryParams extends GetAllGamesParams {
  enabled?: boolean;
}

function useGamesQuery(params: UseGamesQueryParams = {}) {
  const { enabled, ...apiParams } = params;

  const query = useQuery({
    queryKey: [QUERY_KEYS.GAME.ALL_GAMES, apiParams],
    queryFn: () => handleGetAllGames(apiParams),
    enabled,
  });

  return query;
}

export default useGamesQuery;
